import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Tarayıcı dilini kontrol et veya localStorage'dan al
    const savedLanguage = localStorage.getItem('masgold-language');
    if (savedLanguage) {
      return savedLanguage;
    }
    // Tarayıcı dilini kontrol et
    const browserLang = navigator.language || navigator.userLanguage;
    return browserLang.startsWith('tr') ? 'tr' : 'en';
  });

  const toggleLanguage = () => {
    const newLanguage = language === 'tr' ? 'en' : 'tr';
    setLanguage(newLanguage);
    localStorage.setItem('masgold-language', newLanguage);
  };

  const t = (key, fallback = '') => {
    const translations = {
      tr: {
        // Header
        'nav.home': 'Sarrafiye & Gram Altın',
        'nav.milyem': 'Milyem',
        'nav.about': 'Hakkımızda',
        'nav.compliance': 'Uyum',
        'nav.bilgiToplum': 'Bilgi Toplum Hizmetleri',
        'nav.contact': 'İletişim',
        
        // HomePage
        'home.price_info': 'Fiyatlarımız bilgi amaçlıdır.',
        'home.change': 'DEĞİŞİM',
        'home.buy': 'ALIŞ',
        'home.sell': 'SATIŞ',
        'home.gold': 'ALTIN',
        'home.currency': 'DÖVİZ',
        'home.category': 'KATEGORİ',
        'home.buy_sell': 'ALIŞ SATIŞ',
        'home.increase': 'Artış',
        'home.decrease': 'Azalış',
        'home.category.gold': 'Altın',
        'home.category.currency_bureau': 'SARRAFİYE',
        'home.category.currencies': 'DÖVİZ',
        'home.category.sarrafiye_milyem': 'SARRAFİYE MİLYEM',
        'home.category.gram_altin_milyem': 'GRAM ALTIN MİLYEM',
        
        // AboutPage
        'about.title': 'Hakkımızda',
        'about.subtitle': 'MASGOLD Kıymetli Madenler A.Ş., İstanbul merkezli bir kıymetli madenler ticaret şirketi olup Borsa İstanbul Kıymetli Madenler ve Taşlar Piyasası üyesidir.',
        'about.history.title': 'MASGOLD Hakkında',
        'about.history.content1': 'Şirket, hem yurtiçi hem de uluslararası altın piyasalarında aktif olarak faaliyet göstermekte olup müşterilerine rekabetçi fiyatlama ve güvenilir işlem kabiliyeti sunmaktadır.',
        'about.history.content2': 'MASGOLD; fiziki altın ticareti, bullion piyasaları ve uluslararası kıymetli maden akışları konusunda uzmanlaşmıştır.',
        'about.history.content3': 'Bankalar, rafineriler ve kurumsal karşı taraflar ile kurduğu güçlü ve yerleşik ilişkiler sayesinde etkin piyasa erişimi ve sorunsuz işlem gerçekleştirme imkânı sağlamaktadır.',
        'about.history.content4': 'İstanbul’un küresel altın ticaretindeki stratejik konumundan güç alan MASGOLD, yerel ve uluslararası piyasalar arasında köprü görevi üstlenerek likiditeyi artırmakta ve piyasa verimliliğine katkı sağlamaktadır.',
        
        // Mission, Vision, Values
        'about.mission.title': 'Misyonumuz',
        'about.mission.content': 'Kıymetli Madenler sektöründe güvenilirliği ve kaliteyi ön planda tutarak; müşterilerimize her zaman doğru, hızlı ve şeffaf hizmet sunmayı, 18k, 21k ve 22k kategorilerinde uzmanlaşmış toptan ticaret anlayışımızla global pazarda güçlü konumumuzu sürdürmeyi misyon edindik.',
        'about.vision.title': 'Vizyonumuz',
        'about.vision.content': 'Sektörel fuarlara katılımımız ve yenilikçi yaklaşımımızla, dünyanın farklı noktalarındaki müşterilerimize kaliteli ve güvenilir hizmetler sunan, tasarım ve üretim inovasyonları ile global işbirlikçiler portföyünü sürekli geliştiren lider bir Kıymetli Madenler markası olmayı hedefliyoruz.',
        'about.values.title': 'Değerlerimiz',
        'about.values.content': 'Ticaretin temelinde güvenin yer aldığına inanırız; bu nedenle tüm süreçlerimizde şeffaflık, kaliteli ürün, gelişime açık kurum kültürü, başarılı ekibimiz ve değişen koşullara hızla adapte olabilen dinamik bir yapı en büyük değerlerimizdir.',
        
        // Trust Process
        'about.trust.title': 'Her Adımda Güven',
        'about.trust.description': 'Talep ile başlayan süreci, onay ve teslim aşamalarına kadar tamamen kontrolümüzde ve müşterimizin bilgisi dahilinde yürütüyoruz. Güven bizim için ticaretin temelidir.',
        'about.trust.step1.title': 'Neden MASGOLD?',
        'about.trust.step1.content': 'Yıllara dayanan tecrübemiz, sürekli güncellenen fiyatlarımız, hazır stok gücümüz ve birebir iletişimde sağladığımız şeffaflık ile toptan altın ticaretinde tercih edilen güvenilir bir markayız.',
        'about.trust.step2.title': 'İşleyiş Modelimiz',
        'about.trust.step2.content': 'Hızlı talep, anlık fiyatlama, onaylı sipariş ve güçlü stoktan anında temin - MASGOLD işleyişi, basit ama etkili adımlarla ilerler.',
        'about.trust.step3.title': 'Güvenin Adımları',
        'about.trust.step3.content': 'Her işlemde şeffaf, hızlı ve çözüm odaklı bir yapı ile ilerliyoruz. Talebinizden ürün teslimine kadar tüm süreç bizim kontrolümüzde, sizin güvenliğinizle yürütülür.',
        
        // Mobile App
        'about.mobile.title': 'MASGOLD Mobil Uygulaması',
        'about.mobile.feature1.title': 'Anlık Takip',
        'about.mobile.feature1.content': 'Mobil telefonunuzdan altın fiyatlarını anlık takip edin, piyasa değişimlerini anında görün.',
        'about.mobile.feature2.title': 'Sade ve Hızlı Arayüz',
        'about.mobile.feature2.content': 'Karmaşasız, sade tasarım ile fiyatları anında bulun, uygulamayı kolayca kullanın.',
        'about.mobile.feature3.title': 'Favoriler',
        'about.mobile.feature3.content': 'Sık takip ettiğiniz ürünleri favorilere ekleyin, portföyünüz için kişiselleştirilmiş takip listesi oluşturun.',
        'about.mobile.feature4.title': 'Çeviri Aracı',
        'about.mobile.feature4.content': 'Bir miktar girerek anlık kurlar üzerinden Türk Lirası, Dolar ve Euro karşılığını kolayca hesaplayın.',
        'about.mobile.feature5.title': 'Karanlık Mod Desteği',
        'about.mobile.feature5.content': 'Gece veya düşük ışık ortamlarında gözü yormayan karanlık mod seçeneği ile deneyiminizi kişiselleştirin.',
        'about.mobile.download.title': 'Hemen İndirin',
        'about.mobile.light_theme': 'MASGOLD Mobil Uygulama - Açık Tema',
        'about.mobile.dark_theme': 'MASGOLD Mobil Uygulama - Koyu Tema',
        
        // AraHakkimizda
        'ara_about.title': 'Hakkımızda',
        'ara_about.subtitle': 'İstanbul merkezli kıymetli madenler ticareti',
        'ara_about.content1': 'MASGOLD Kıymetli Madenler A.Ş., İstanbul merkezli bir kıymetli madenler ticaret şirketi olup Borsa İstanbul Kıymetli Madenler ve Taşlar Piyasası üyesidir.',
        'ara_about.content2': 'Şirket, hem yurtiçi hem de uluslararası altın piyasalarında aktif olarak faaliyet göstermekte; rekabetçi fiyatlama ve güvenilir işlem kabiliyeti sunmaktadır.',
        'ara_about.content3': 'Fiziki altın ticareti, bullion piyasaları ve uluslararası kıymetli maden akışları konularında uzmanlaşmıştır.',
        'ara_about.content4': 'Bankalar, rafineriler ve kurumsal karşı taraflarla kurduğu güçlü ilişkilerle hızlı ve sorunsuz işlem yürütür; İstanbul’un stratejik konumuyla yerel ve uluslararası piyasalar arasında köprü kurar.',
        'ara_about.image_alt': 'Masgold Kıymetli Madenler A.Ş. Mağaza',
        
        // Mob
        'mob.title': 'Mobil Uygulaması',
        'mob.subtitle': 'MASGOLD mobil uygulaması ile piyasaları her yerden takip edin',
        'mob.download.title': 'Hemen İndirin',
        'mob.download.description': 'App Store ve Google Play\'den ücretsiz indirin',
        'mob.preview1': 'Mobil Uygulama Önizleme 1',
        'mob.preview2': 'Mobil Uygulama Önizleme 2',
        'mob.feature1.title': 'Anlık Takip',
        'mob.feature1.description': 'Altın fiyatlarını anlık olarak cep telefonunuzdan izleyebilir, piyasadaki değişimleri anında görebilirsiniz.',
        'mob.feature2.title': 'Sade ve Hızlı Arayüz',
        'mob.feature2.description': 'Karmaşadan uzak, sade tasarımı sayesinde fiyatları anında bulabilir, uygulamayı kolayca kullanabilirsiniz.',
        'mob.feature3.title': 'Favoriler',
        'mob.feature3.description': 'Sık takip ettiğiniz ürünleri favorilerinize ekleyerek tek dokunuşla hızlı erişim sağlayabilir, portföyünüze özel takip listesi oluşturabilirsiniz.',
        'mob.feature4.title': 'Çeviri Aracı',
        'mob.feature4.description': 'Belirttiğiniz miktarı girerek anlık kur bilgisine göre Türk Lirası, Dolar ve Euro karşılıklarını kolayca hesaplayabilirsiniz.',
        'mob.feature5.title': 'Karanlık Mod Desteği',
        'mob.feature5.description': 'Gece veya loş ortamlarda göz yormayan karanlık mod seçeneğiyle kullanıcı deneyiminizi kişiselleştirin.',
        
        // ContactPage
        'contact.title': 'İletişim',
        'contact.subtitle': 'Bizimle iletişime geçin, size yardımcı olmaktan mutluluk duyarız',
        'contact.phone.title': 'Telefon',
        'contact.phone.number': '0090 501 002 00 00',
        'contact.phone.hours': 'Pazartesi - Cuma: 09:00 - 18:00',
        'contact.address.title': 'Adres',
        'contact.address.main': 'MERKEZ',
        'contact.address.main_text': 'Levazım Mah. Vadi Cad. Zorlu Center No:2 İç Kapı No: 568',
        'contact.address.branch': 'Toptan (Bayi)',
        'contact.address.branch_text': 'Mollafenari Mahallesi Tavukpazarı Sokak No:13 Çemberlitaş, 34120 Fatih',
        'contact.email.title': 'E-posta',
        'contact.email.address': 'masgold@masgold.com',
        'contact.email.hours': 'Pazartesi - Cuma: 09:00 - 18:00',
        'contact.hours.title': 'Çalışma Saatleri',
        'contact.hours.weekdays': 'Pazartesi - Cuma: 09:00 - 18:00',
        'contact.hours.saturday': 'Cumartesi: 09:00 - 14:00',
        'contact.form.title': 'Bize Ulaşın',
        'contact.form.description': 'Kıymetli maden işlemleriniz için profesyonel destek almak istiyorsanız, aşağıdaki formu doldurarak bizimle iletişime geçebilirsiniz. Uzman ekibimiz en kısa sürede size dönüş yapacaktır.',
        'contact.form.feature1.title': 'Hızlı Yanıt',
        'contact.form.feature1.content': '24 saat içinde yanıt garantisi',
        'contact.form.feature2.title': 'WhatsApp Destek',
        'contact.form.feature2.content': 'Anlık mesajlaşma ile hızlı iletişim',
        'contact.form.feature3.title': 'Uzman Destek',
        'contact.form.feature3.content': 'Deneyimli ekip ile profesyonel hizmet',
        'contact.form.name': 'Ad Soyad *',
        'contact.form.name_placeholder': 'Adınız ve soyadınız',
        'contact.form.email': 'E-posta *',
        'contact.form.email_placeholder': 'E-posta adresiniz',
        'contact.form.phone': 'Telefon',
        'contact.form.phone_placeholder': 'Telefon numaranız',
        'contact.form.subject': 'Konu *',
        'contact.form.subject_placeholder': 'Konu seçiniz',
        'contact.form.subject1': 'Kıymetli Maden Alış',
        'contact.form.subject2': 'Kıymetli Maden Satış',
        'contact.form.subject4': 'Toptan Satış',
        'contact.form.subject5': 'Genel Bilgi',
        'contact.form.subject6': 'Diğer',
        'contact.form.message': 'Mesaj *',
        'contact.form.message_placeholder': 'Mesajınızı buraya yazın...',
        'contact.form.submit': 'Mesaj Gönder',
        'contact.form.submitting': 'Gönderiliyor...',
        'contact.form.success': 'Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.',
        'contact.locations.title': 'Konumlarımız',
        'contact.locations.main': 'Merkez',
        'contact.locations.branch': 'Toptan(Bayi)',
        'contact.whatsapp.title': 'WhatsApp ile Hızlı İletişim',
        'contact.whatsapp.description': 'Anlık fiyat bilgisi ve hızlı işlemler için WhatsApp\'tan bize ulaşın',
        'contact.whatsapp.button': 'WhatsApp\'tan Yaz',
        'contact.whatsapp.alt': 'WhatsApp',
        'contact.locations.main_title': 'Merkez Ofis Konumu',
        'contact.locations.branch_title': 'Toptan(Bayi) Konumu',
        
        // UyumPage
        'compliance.title': 'Uyum ve Belgelendirme',
        'compliance.subtitle': 'MasGold olarak, sektördeki en yüksek standartlara uygun şekilde faaliyet göstermekteyiz. Aşağıdaki belgelerimizi inceleyebilirsiniz.',
        'compliance.documents.title': 'Borsa Evrakları',
        'compliance.documents.category': 'BORSA-EVRAK',
        'compliance.documents.doc1': 'MASGOLD BORSA ÜYELİK BELGESİ',
        'compliance.documents.doc2': 'MASGOLD MÜŞTERİ TANIMA FORMU',
        'compliance.documents.doc3': 'MASGOLD MÜŞTERİ KABUL BEYANI',
        'compliance.documents.doc4': 'MASGOLD İÇ KONTROL SİSTEMİ VE TEDARİK ZİNCİRİ UYUM PROĞRAMI',
        'compliance.documents.doc5': 'MASGOLD KIYMETLİ MADENLER SORUMLU TEDARİK ZİNCİRİ UYUM POLİTİKASI',
        'compliance.documents.doc6': 'MASGOLD SORUMLU TEDARİK ZİNCİRİ UYGULAMA TALİMATI',
        'compliance.documents.doc7': 'LBMA Sorumlu Altın Rehberi Dökümü',
        'compliance.documents.doc8': 'MASAK UYUM YÖNETMELİĞİ',
        'compliance.documents.doc9': '2023 YILI KIYMETLI MADENLER SORUMLU TEDARIK ZINCIRI',
        'compliance.documents.doc10': 'BAĞIMSIZ GÜVENCE RAPORU',
        'compliance.documents.doc11': 'SORUMLU TEDARİK ZİNCİRİ YÖNETİM RAPORU',
        'compliance.documents.doc12': 'YÖNETİM KURULU KARARI 25.03.2024',
        'compliance.documents.doc13': 'YÖNETİM KURULU KARARI',
        'compliance.documents.doc14': '24.03.2025 YÖNETİM KURULU KARARI UYUM RAPORU',
        'compliance.documents.doc15': '2024 YILI KIYMETLİ MADENLER SORUMLU TEDARİK ZİNCİRİ UYUM RAPORU',
        'compliance.documents.doc16': '2024 YILI BAĞIMSIZ GÜVENCE RAPORU',
        'compliance.documents.doc17': '2024 YILI STZ YÖNETİM RAPORU',
        'compliance.documents.doc18': '2024 YILI UYUM VE GÜVENCE RAPORU YK',
        'compliance.documents.doc19': '2025 YILI STZ UYUM RAPORU',
        'compliance.documents.doc20': '2025 YILI STZ UYUM RAPORU YK',
        'compliance.documents.doc21': '2025 YILI STZ YÖNETİM RAPORU',
        'compliance.documents.doc22': '2025 YILI BAĞIMSIZ GÜVENCE RAPORU',
        'compliance.documents.doc23': '2025 YILI BAĞIMSIZ GÜVENCE RAPORU YK',
        'compliance.documents.doc24': 'YÖNETİM KURULU KARARI 01.06.2026',
        'compliance.documents.doc25': 'Rüşvet ve Yolsuzlukla Mücadele Politikası (İngilizce)',
        'compliance.documents.doc26': 'İç Kontrol Sistemi ve Tedarik Zinciri Uyum Programı',
        'compliance.documents.doc27': 'İhbar ve Bilgi Uçurma Politikası',
        'compliance.documents.doc28': 'İç Kontrol Sistemi ve Tedarik Zinciri Uyum Programı (İngilizce)',
        'compliance.documents.doc29': 'Kıymetli Maden Alım-Satım Çerçeve Sözleşmesi',
        'compliance.documents.doc30': 'Kıymetli Madenler Sorumlu Tedarik Zinciri Uyum Politikası',
        'compliance.documents.doc31': 'Kıymetli Madenler Sorumlu Tedarik Zinciri Uygulama Talimatı',
        'compliance.documents.doc32': 'Müşteri Kabul Beyanı',
        'compliance.documents.doc33': 'Müşterini Tanı Formu — Gerçek Kişi',
        'compliance.documents.doc34': 'Müşterini Tanı Formu — Tüzel Kişi',
        'compliance.documents.doc35': 'Suç Gelirlerinin Aklanması ve Terörün Finansmanının Önlenmesi Politikası (İngilizce)',
        'compliance.documents.doc36': 'Kıymetli Madenler Sorumlu Tedarik Zinciri Uyum Politikası (İngilizce)',
        'compliance.documents.doc37': 'Rüşvet ve Yolsuzlukla Mücadele Politikası',
        'compliance.documents.doc38': 'Suç Gelirlerinin Aklanması ve Terörün Finansmanının Önlenmesi Hakkında Şirket Politikası',
        'compliance.documents.doc39': 'İhbar ve Bilgi Uçurma Politikası (İngilizce)',
        'compliance.documents.doc40': 'Faaliyet Belgesi',
        'compliance.documents.doc41': 'MASGOLD 2025 Vergi Levhası',
        'compliance.documents.doc42': 'MASGOLD İmza Sirküsü',
        
        // Footer
        'footer.pages': 'Sayfalar',
        'footer.contact_info': 'İletişim Bilgilerimiz',
        'footer.address': 'Adres:',
        'footer.phone': 'Telefon:',
        'footer.email': 'E-posta:',
        'footer.show_map': 'Haritada Göster',
        'footer.description': 'Güvenilir kıymetli maden işlemleri için doğru adres',
        'footer.copyright': '© 2025 AIFASOFT. Tüm hakları saklıdır.',
        'footer.privacy': 'Gizlilik Politikası',
        'footer.terms': 'Kullanım Şartları',
        'footer.logo_alt': 'AIFASOFT',
        'footer.map_title': 'Mağaza Konumu',
        
        // Common
        'common.loading': 'Yükleniyor...',
        'common.error': 'Bir hata oluştu',
        'common.success': 'Başarılı',
        'common.cancel': 'İptal',
        'common.save': 'Kaydet',
        'common.close': 'Kapat',
        'common.app_store': 'App Store',
        'common.google_play': 'Google Play'
      },
      en: {
        // Header
        'nav.home': 'Bullion & Gram Gold',
        'nav.milyem': 'Millesimal',
        'nav.about': 'About Us',
        'nav.compliance': 'Compliance',
        'nav.bilgiToplum': 'Information Society Services',
        'nav.contact': 'Contact',
        
        // HomePage
        'home.price_info': 'Our prices are for informational purposes.',
        'home.change': 'CHANGE',
        'home.buy': 'BUY',
        'home.sell': 'SELL',
        'home.gold': 'GOLD',
        'home.currency': 'CURRENCY',
        'home.category': 'CATEGORY',
        'home.buy_sell': 'BUY SELL',
        'home.increase': 'Increase',
        'home.decrease': 'Decrease',
        'home.category.gold': 'Gold',
        'home.category.currency_bureau': 'Parity',
        'home.category.currencies': 'Currency',
        'home.category.sarrafiye_milyem': 'BULLION MILLESIMAL',
        'home.category.gram_altin_milyem': 'GRAM GOLD MILLESIMAL',
        
        // AboutPage
        'about.title': 'About Us',
        'about.subtitle': 'MASGOLD Kıymetli Madenler A.Ş. is an Istanbul-based precious metals trading company and a member of the Borsa İstanbul Precious Metals Market.',
        'about.history.title': 'About MASGOLD',
        'about.history.content1': 'The company is actively engaged in both domestic and international gold markets, offering competitive pricing and reliable execution to a broad range of clients.',
        'about.history.content2': 'MASGOLD specializes in physical gold trading, bullion markets, and cross-border precious metals flows.',
        'about.history.content3': 'The company maintains strong and well-established relationships with banks, refineries, and institutional counterparties, enabling efficient market access and seamless transaction execution.',
        'about.history.content4': 'Leveraging Istanbul’s strategic position as a global gold trading hub, MASGOLD plays a key role in connecting local and international markets, facilitating liquidity and enhancing market efficiency.',
        
        // Mission, Vision, Values
        'about.mission.title': 'Our Mission',
        'about.mission.content': 'We have made it our mission to always provide correct, fast and transparent service to our customers by prioritizing reliability and quality in the precious metals sector; to maintain our strong position in the global market with our wholesale trade understanding specialized in 18k, 21k and 22k categories.',
        'about.vision.title': 'Our Vision',
        'about.vision.content': 'With our participation in sectoral fairs and innovative approach, we aim to be a leading precious metals brand that provides quality and reliable services to our customers in different parts of the world, and continuously develops its global collaborators portfolio with design and production innovations.',
        'about.values.title': 'Our Values',
        'about.values.content': 'We believe that trust is at the foundation of trade; therefore, transparency in all our processes, quality products, open-to-development corporate culture, our successful team and a dynamic structure that can quickly adapt to changing conditions are our greatest values.',
        
        // Trust Process
        'about.trust.title': 'Trust at Every Step',
        'about.trust.description': 'We carry out the process starting with the request, from approval to delivery stages, completely under our control and with the knowledge of our customer. Trust is the foundation of trade for us.',
        'about.trust.step1.title': 'Why MASGOLD?',
        'about.trust.step1.content': 'We are a reliable brand preferred in wholesale gold trade with our years of experience, constantly updated prices, ready stock power and transparency we provide in one-on-one communication.',
        'about.trust.step2.title': 'Our Business Model',
        'about.trust.step2.content': 'Fast request, instant pricing, approved order and immediate supply from strong stock - MASGOLD operation proceeds with simple but effective steps.',
        'about.trust.step3.title': 'Steps of Trust',
        'about.trust.step3.content': 'We proceed with a transparent, fast and solution-oriented structure in every transaction. The entire process from your request to product delivery is under our control and carried out with your security.',
        
        // Mobile App
        'about.mobile.title': 'MASGOLD Mobile Application',
        'about.mobile.feature1.title': 'Real-time Tracking',
        'about.mobile.feature1.content': 'Track gold prices in real-time from your mobile phone, see market changes instantly.',
        'about.mobile.feature2.title': 'Simple and Fast Interface',
        'about.mobile.feature2.content': 'Find prices instantly with an uncluttered, simple design, use the app easily.',
        'about.mobile.feature3.title': 'Favorites',
        'about.mobile.feature3.content': 'Add the products you follow frequently to favorites, create a personalized tracking list for your portfolio.',
        'about.mobile.feature4.title': 'Conversion Tool',
        'about.mobile.feature4.content': 'Easily calculate the equivalent in Turkish Lira, Dollar and Euro by entering an amount based on current exchange rates.',
        'about.mobile.feature5.title': 'Dark Mode Support',
        'about.mobile.feature5.content': 'Personalize your experience with dark mode option that doesn\'t strain your eyes in night or low light environments.',
        'about.mobile.download.title': 'Download Now',
        'about.mobile.light_theme': 'MASGOLD Mobile Application - Light Theme',
        'about.mobile.dark_theme': 'MASGOLD Mobile Application - Dark Theme',
        
        // AraHakkimizda
        'ara_about.title': 'About Us',
        'ara_about.subtitle': 'Istanbul-based precious metals trading',
        'ara_about.content1': 'MASGOLD Kıymetli Madenler A.Ş. is an Istanbul-based precious metals trading company and a member of the Borsa İstanbul Precious Metals Market.',
        'ara_about.content2': 'The company is actively engaged in both domestic and international gold markets, offering competitive pricing and reliable execution to a broad range of clients.',
        'ara_about.content3': 'MASGOLD specializes in physical gold trading, bullion markets, and cross-border precious metals flows.',
        'ara_about.content4': 'With strong relationships across banks, refineries, and institutional counterparties, MASGOLD enables efficient market access and seamless execution—leveraging Istanbul’s role to connect local and international markets.',
        'ara_about.image_alt': 'Masgold Precious Metals Inc. Store',
        
        // Mob
        'mob.title': 'Mobile Application',
        'mob.subtitle': 'Track markets from anywhere with MASGOLD mobile application',
        'mob.download.title': 'Download Now',
        'mob.download.description': 'Download for free from App Store and Google Play',
        'mob.preview1': 'Mobile Application Preview 1',
        'mob.preview2': 'Mobile Application Preview 2',
        'mob.feature1.title': 'Real-time Tracking',
        'mob.feature1.description': 'You can monitor gold prices in real-time from your mobile phone and see market changes instantly.',
        'mob.feature2.title': 'Simple and Fast Interface',
        'mob.feature2.description': 'Thanks to its uncluttered, simple design, you can find prices instantly and use the app easily.',
        'mob.feature3.title': 'Favorites',
        'mob.feature3.description': 'You can add the products you follow frequently to your favorites for quick access with one touch and create a personalized tracking list for your portfolio.',
        'mob.feature4.title': 'Conversion Tool',
        'mob.feature4.description': 'You can easily calculate the equivalent in Turkish Lira, Dollar and Euro by entering the amount you specify based on current exchange rate information.',
        'mob.feature5.title': 'Dark Mode Support',
        'mob.feature5.description': 'Personalize your user experience with dark mode option that doesn\'t strain your eyes in night or dim environments.',
        
        // ContactPage
        'contact.title': 'Contact',
        'contact.subtitle': 'Contact us, we are happy to help you',
        'contact.phone.title': 'Phone',
        'contact.phone.number': '0090 501 002 00 00',
        'contact.phone.hours': 'Monday - Friday: 09:00 - 18:00',
        'contact.address.title': 'Address',
        'contact.address.main': 'HEAD OFFICE',
        'contact.address.main_text': 'Levazım Mah. Vadi Cad. Zorlu Center No:2 İç Kapı No: 568',
        'contact.address.branch': 'Wholesale (Dealer)',
        'contact.address.branch_text': 'Mollafenari Mahallesi Tavukpazarı Sokak No:13 Çemberlitaş, 34120 Fatih',
        'contact.email.title': 'Email',
        'contact.email.address': 'masgold@masgold.com',
        'contact.email.hours': 'Monday - Friday: 09:00 - 18:00',
        'contact.hours.title': 'Working Hours',
        'contact.hours.weekdays': 'Monday - Friday: 09:00 - 18:00',
        'contact.hours.saturday': 'Saturday: 09:00 - 14:00',
        'contact.form.title': 'Contact Us',
        'contact.form.description': 'If you want to get professional support for your precious metals transactions, you can contact us by filling out the form below. Our expert team will get back to you as soon as possible.',
        'contact.form.feature1.title': 'Quick Response',
        'contact.form.feature1.content': '24-hour response guarantee',
        'contact.form.feature2.title': 'WhatsApp Support',
        'contact.form.feature2.content': 'Fast communication with instant messaging',
        'contact.form.feature3.title': 'Expert Support',
        'contact.form.feature3.content': 'Professional service with experienced team',
        'contact.form.name': 'Full Name *',
        'contact.form.name_placeholder': 'Your name and surname',
        'contact.form.email': 'Email *',
        'contact.form.email_placeholder': 'Your email address',
        'contact.form.phone': 'Phone',
        'contact.form.phone_placeholder': 'Your phone number',
        'contact.form.subject': 'Subject *',
        'contact.form.subject_placeholder': 'Select subject',
        'contact.form.subject1': 'Precious Metal Purchase',
        'contact.form.subject2': 'Precious Metal Sale',
        'contact.form.subject4': 'Wholesale Sale',
        'contact.form.subject5': 'General Information',
        'contact.form.subject6': 'Other',
        'contact.form.message': 'Message *',
        'contact.form.message_placeholder': 'Write your message here...',
        'contact.form.submit': 'Send Message',
        'contact.form.submitting': 'Sending...',
        'contact.form.success': 'Your message has been sent successfully! We will get back to you as soon as possible.',
        'contact.locations.title': 'Our Locations',
        'contact.locations.main': 'Wholesale (Dealer)',
        'contact.locations.branch': 'Branch Office',
        'contact.whatsapp.title': 'Quick Contact via WhatsApp',
        'contact.whatsapp.description': 'Contact us via WhatsApp for instant price information and fast transactions',
        'contact.whatsapp.button': 'Write on WhatsApp',
        'contact.whatsapp.alt': 'WhatsApp',
        'contact.locations.main_title': 'Main Office Location',
        'contact.locations.branch_title': 'Branch Office Location',
        
        // UyumPage
        'compliance.title': 'Compliance and Certification',
        'compliance.subtitle': 'As MasGold, we operate in accordance with the highest standards in the industry. You can review our documents below.',
        'compliance.documents.title': 'Exchange Documents',
        'compliance.documents.category': 'EXCHANGE-DOCUMENT',
        'compliance.documents.doc1': 'MASGOLD EXCHANGE MEMBERSHIP DOCUMENT',
        'compliance.documents.doc2': 'MASGOLD CUSTOMER IDENTIFICATION FORM',
        'compliance.documents.doc3': 'MASGOLD CUSTOMER ACCEPTANCE DECLARATION',
        'compliance.documents.doc4': 'MASGOLD INTERNAL CONTROL SYSTEM AND SUPPLY CHAIN COMPLIANCE PROGRAM',
        'compliance.documents.doc5': 'MASGOLD PRECIOUS METALS RESPONSIBLE SUPPLY CHAIN COMPLIANCE POLICY',
        'compliance.documents.doc6': 'MASGOLD RESPONSIBLE SUPPLY CHAIN IMPLEMENTATION INSTRUCTION',
        'compliance.documents.doc7': 'LBMA Responsible Gold Guide Dump',
        'compliance.documents.doc8': 'MASAK COMPLIANCE REGULATION',
        'compliance.documents.doc9': '2023 PRECIOUS METALS RESPONSIBLE SUPPLY CHAIN',
        'compliance.documents.doc10': 'INDEPENDENT ASSURANCE REPORT',
        'compliance.documents.doc11': 'RESPONSIBLE SUPPLY CHAIN MANAGEMENT REPORT',
        'compliance.documents.doc12': 'BOARD OF DIRECTORS DECISION 25.03.2024',
        'compliance.documents.doc13': 'BOARD OF DIRECTORS DECISION',
        'compliance.documents.doc14': '24.03.2025 BOARD OF DIRECTORS DECISION COMPLIANCE REPORT',
        'compliance.documents.doc15': '2024 PRECIOUS METALS RESPONSIBLE SUPPLY CHAIN COMPLIANCE REPORT',
        'compliance.documents.doc16': '2024 INDEPENDENT ASSURANCE REPORT',
        'compliance.documents.doc17': '2024 STZ MANAGEMENT REPORT',
        'compliance.documents.doc18': '2024 COMPLIANCE AND ASSURANCE REPORT YK',
        'compliance.documents.doc19': '2025 Responsible Supply Chain (STZ) Compliance Report',
        'compliance.documents.doc20': '2025 STZ Compliance Report — Board (YK)',
        'compliance.documents.doc21': '2025 STZ Management Report',
        'compliance.documents.doc22': '2025 Independent Assurance Report',
        'compliance.documents.doc23': '2025 Independent Assurance Report — Board (YK)',
        'compliance.documents.doc24': 'BOARD OF DIRECTORS DECISION 01.06.2026',
        'compliance.documents.doc25': 'Anti-Bribery and Anti-Corruption Policy',
        'compliance.documents.doc26': 'Internal Control System and Supply Chain Compliance Programme',
        'compliance.documents.doc27': 'Whistleblowing Policy',
        'compliance.documents.doc28': 'Internal Control System and Supply Chain Compliance Programme',
        'compliance.documents.doc29': 'Precious Metals Purchase-Sale Framework Agreement',
        'compliance.documents.doc30': 'Precious Metals Responsible Supply Chain Compliance Policy',
        'compliance.documents.doc31': 'Precious Metals Responsible Supply Chain Implementation Instruction',
        'compliance.documents.doc32': 'Customer Acceptance Declaration',
        'compliance.documents.doc33': 'Customer Identification Form — Natural Person',
        'compliance.documents.doc34': 'Customer Identification Form — Legal Entity',
        'compliance.documents.doc35': 'Policy on the Prevention of Money Laundering and the Financing of Terrorism',
        'compliance.documents.doc36': 'Precious Metals Responsible Supply Chain Compliance Policy',
        'compliance.documents.doc37': 'Anti-Bribery and Anti-Corruption Policy',
        'compliance.documents.doc38': 'Company Policy on the Prevention of Money Laundering and the Financing of Terrorism',
        'compliance.documents.doc39': 'Whistleblowing Policy',
        'compliance.documents.doc40': 'Activity Certificate',
        'compliance.documents.doc41': 'MASGOLD 2025 Tax Plate',
        'compliance.documents.doc42': 'MASGOLD Signature Circular',
        
        // Footer
        'footer.pages': 'Pages',
        'footer.contact_info': 'Our Contact Information',
        'footer.address': 'Address:',
        'footer.phone': 'Phone:',
        'footer.email': 'Email:',
        'footer.show_map': 'Show on Map',
        'footer.description': 'The right address for reliable precious metals transactions',
        'footer.copyright': '© 2025 AIFASOFT. All rights reserved.',
        'footer.privacy': 'Privacy Policy',
        'footer.terms': 'Terms of Use',
        'footer.logo_alt': 'AIFASOFT',
        'footer.map_title': 'Store Location',
        
        // Common
        'common.loading': 'Loading...',
        'common.error': 'An error occurred',
        'common.success': 'Success',
        'common.cancel': 'Cancel',
        'common.save': 'Save',
        'common.close': 'Close',
        'common.app_store': 'App Store',
        'common.google_play': 'Google Play'
      }
    };
    
    return translations[language]?.[key] || fallback || key;
  };

  useEffect(() => {
    // Dil değiştiğinde document title'ı güncelle
    document.documentElement.lang = language;
  }, [language]);

  const value = {
    language,
    toggleLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
